module.exports = __webpack_public_path__ + "fonts/GeneralSans-Bold.c72b454e.ttf";